import { lazy } from "react";
import PropTypes from "prop-types";

export default function funcLazyDelayPage(NamePage) {
	const result = lazy(() => {
		return Promise.all([
			import(`../pages/${NamePage}`),
			new Promise(resolve => setTimeout(resolve, 500)),
		]).then(([moduleExports]) => moduleExports);
	});
	return result;
}
funcLazyDelayPage.propTypes = {
	NamePage: PropTypes.string.isRequired,
};
